import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  normalizeTranslationLocale,
  resolveCurrentTranslationLocale,
  type TranslationLocale,
} from './language';

interface TranslationState {
  isTranslationEnabled: boolean;
  targetLocale: TranslationLocale;
  setTranslationEnabled: (enabled: boolean) => void;
  toggleTranslation: () => void;
  setTargetLocale: (locale: string) => void;
}

export const useTranslationStore = create<TranslationState>()(
  persist(
    set => ({
      isTranslationEnabled: true,
      targetLocale: resolveCurrentTranslationLocale(),
      setTranslationEnabled: enabled => set({ isTranslationEnabled: enabled }),
      toggleTranslation: () =>
        set(state => ({ isTranslationEnabled: !state.isTranslationEnabled })),
      setTargetLocale: locale => set({ targetLocale: normalizeTranslationLocale(locale) }),
    }),
    {
      name: 'jema-translation-preferences',
    }
  )
);
